import * as React from 'react';

export const CompositeJobCompany: React.FC<{
  jobTitle?: string | null;
  company?: string | null;
}> = ({ jobTitle, company }) => {
  const compositeJobCompany = [
    ...(jobTitle ? [jobTitle] : []),
    ...(company ? [company] : []),
  ].join(', ');

  return <>{compositeJobCompany}</>;
};
